/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import {createPortal} from 'react-dom'
import {Modal} from 'react-bootstrap'


import {KTSVG} from '../../../../../_metronic/helpers'


//import { defaultCreateAppData, ICreateAppData } from '../../../../../_metronic/partials/modals/create-app-stepper/IAppModels'

//import { postCredentialVerificad } from '../../../../services/credentialService'
import { useToast } from '../../../components/Toats'
import { LoadingSpan } from '../../../components/Loadings/loadingSpan'
import { useFormik } from 'formik'
import * as Yup from "yup";
//import { getCompanyAll } from '../../../../services/companyService'
//import { postUnitBranch, updateUnitBranch } from '../../../../services/unitBranchService'
import { StepModal } from './components/stepModal'
//import { postClient, updateClient } from '../../../../services/clientService'
//import { postUnitConsumerAll, updateUnitConsumerAll } from '../../../../services/unitConsumerService'
import { updateInvoice } from '../../../../services/invoices'
import styles from '../../../unit-consumer/components/ModalAddEditUnitConsumer/modalUnitConsumer.module.css'

type DataForm = {
  mes: Date | null,
  data_vencimento: string | null,
  energia_faturada: string | null,
  energia_injetada: string | null,
  energia_registrada: string | null,
  energia_compensada: string | null,
  leitura_atual: string | null,
  leitura_anterior: string | null,
  leitura_proxima: string | null,
  tarifa: string | null,
  creditos: string | null,
  tipo_fornecimento: string | null,
  valor_faturado: string | null,
  valor_economizado: string | null,
  confirm_payment: boolean | null,
  link_file: string | null,
  base64: string | null,
  status: string | null,
  idConcessionarie: string | null,
  idUnitConsumer: string | null,

  taxa_iluminacao: string | null;
  icms: string | null;
  pis: string | null;
  cofins: string | null;

  valor_consumido: string | null;
  codigo_instalacao: string | null;
  grupo_tarifario: string | null;
  /** Seleção manual A/B; controla exibição dos campos de Grupo A na UI */
  tipo_fatura_ab: 'A' | 'B';
  modalidade_tarifaria: string | null;
  concessionaria: string | null;
  regulamentacao_aneel: boolean | null;
  demanda_contratada_kw: string | null;
  demanda_medida_kw: string | null;
  demanda_faturada_kw: string | null;
  ultrapassagem_kw: string | null;
  fator_potencia: string | null;
  consumo_ponta_kwh: string | null;
  consumo_fora_ponta_kwh: string | null;
  bandeira_tarifaria_vigente: string | null;
  tarifa_tusd: string | null;
  tarifa_te: string | null;
  tarifa_media: string | null;
  tarifa_tusd_ponta: string | null;
  tarifa_tusd_fora_ponta: string | null;
  tarifa_te_ponta: string | null;
  tarifa_te_fora_ponta: string | null;
  tarifa_demanda_contratada: string | null;
  preco_unitario_ponta: string | null;
  preco_unitario_fora_ponta: string | null;
  contrib_ilum_publica: string | null;
  itens_faturamento_json: string | null;
  medicao_json: string | null;
  historico_consumo_json: string | null;
  tarifas_json: string | null;
  demandas_grupo_a_json: string | null;
  impostos_json: string | null;
}

type Props = {
    id?: string;
    data?: DataForm;
    show: boolean
    handleClose: () => void
}

const validationSchema = Yup.object().shape({
  mes: Yup.string().required("Informe o mês referencia"),
  data_vencimento: Yup.string().required("Informe a data de vencimento da fatura"),
  energia_faturada: Yup.string().required("Informe a energia faturada"),
  energia_injetada: Yup.string().required("Informe a energia injetada"),
  energia_registrada: Yup.string().required("Informe a energia registrada"),
  energia_compensada: Yup.string().required("Informe a energia compensada"),
  leitura_atual: Yup.string().required("Informe a leitura atual"),
  leitura_anterior: Yup.string().required("Informe a leitura anterior"),
  tarifa: Yup.string().required("Informe a tarifa"),
  valor_economizado: Yup.string().required("Informe o valor economizado"),
  creditos: Yup.string(),
  tipo_fornecimento: Yup.string().required("Informe o tipo de fornecimento"),
  valor_faturado: Yup.string().required("Informe o valor faturado"),
  confirm_payment: Yup.boolean(),
  link_file: Yup.string(),
  base64:  Yup.string(),
  status: Yup.string(),
  idConcessionarie: Yup.string().required("Informe a concessionária"),
  idUnitConsumer: Yup.string().required("Informe a unidade consumidora."),
});

const modalsRoot = document.getElementById('root-modals') || document.body

const tipoFaturaAbFromGrupo = (grupo: string | null | undefined): 'A' | 'B' => {
  const g = (grupo ?? '').trim().toUpperCase()
  return g.startsWith('A') ? 'A' : 'B'
}

const ModalAddUpdateInvoice = ({show, handleClose, data, id}: Props) => {


  const { toggleToast } = useToast();

  const [initialValues, setInitialValues] = useState<DataForm>({
    mes: new Date(),
    data_vencimento: null,
    energia_faturada: null,
    energia_injetada: null,
    energia_registrada: null,
    energia_compensada: null,
    leitura_atual: new Date().toISOString(),
    leitura_anterior: new Date().toISOString(),
    leitura_proxima: new Date().toISOString(),
    tarifa: null,
    tipo_fornecimento: null,
    valor_faturado: null,
    valor_economizado: null,
    link_file: null,
    creditos: null,
    base64: null,
    status: "NÃO INFORMADO",
    idConcessionarie: null,
    idUnitConsumer: null,
    confirm_payment: false,
    taxa_iluminacao: "",
    icms: "",
    pis: "",
    cofins: "",

    valor_consumido: null,
    codigo_instalacao: null,
    grupo_tarifario: null,
    tipo_fatura_ab: 'B',
    modalidade_tarifaria: null,
    concessionaria: null,
    regulamentacao_aneel: false,
    demanda_contratada_kw: null,
    demanda_medida_kw: null,
    demanda_faturada_kw: null,
    ultrapassagem_kw: null,
    fator_potencia: null,
    consumo_ponta_kwh: null,
    consumo_fora_ponta_kwh: null,
    bandeira_tarifaria_vigente: null,
    tarifa_tusd: null,
    tarifa_te: null,
    tarifa_media: null,
    tarifa_tusd_ponta: null,
    tarifa_tusd_fora_ponta: null,
    tarifa_te_ponta: null,
    tarifa_te_fora_ponta: null,
    tarifa_demanda_contratada: null,
    preco_unitario_ponta: null,
    preco_unitario_fora_ponta: null,
    contrib_ilum_publica: null,
    itens_faturamento_json: null,
    medicao_json: null,
    historico_consumo_json: null,
    tarifas_json: null,
    demandas_grupo_a_json: null,
    impostos_json: null,
  })
  const [hasError, setHasError] = useState(false)
  //const [myError, MyError] = useState(false)
  const [loading, setLoading] = useState(false)
  
  const updateData = (fieldsToUpdate: any) => {
    const updatedData = {...initialValues, ...fieldsToUpdate}
    setInitialValues(updatedData)
  }

  const checkInputs = (): boolean => {
    if (!formik.values.mes 
        || !formik.values.idUnitConsumer
        || !formik.values.energia_faturada
        || !formik.values.energia_registrada
        || !formik.values.leitura_anterior
        || !formik.values.tarifa
        || !formik.values.valor_faturado 
      ) {
      return false
    }
    return true
  }

  const closed = () => {
    formik.setValues(initialValues)
    handleClose()
  }

  // const updateUnitConsumerSubmit = async () => {
  //   try {
  //     setLoading(true)
  //     const myData = {
  //       mes: formik.values.mes,
  //       status: "INFORMADO",
  //       idUnitConsumer: formik.values.idUnitConsumer
  //     }
  //     Object.keys(myData).forEach((prop) => {
  //       if (myData[prop] === null) {
  //         delete myData[prop];
  //       }
  //     });

  //     const myFilial = await postUnitConsumerAll(myData)
  //     toggleToast("Sucesso ao cadastrar a unidade consumidora. ", "success")
  //     console.log(myFilial)

  //   } catch (error) {
  //     console.log('erro',error)
  //     toggleToast("Erro ao cadastrar o cliente. ", "error")
  //   }finally{
  //     setLoading(false)
  //     closed()
  //     // handleClose()
  //     // setTimeout(()=>{
  //     //   window.location.reload()
  //     // }, 2000);
  //   }
  // }

  const updateUnitConsumerSubmit = async (id: string) => {
    try {
      setLoading(true)
      const myData = {
        data_vencimento: formik.values.data_vencimento ? formik.values.data_vencimento : null,
        energia_faturada: formik.values.energia_faturada ? formik.values.energia_faturada : null,
        energia_injetada: formik.values.energia_injetada ? formik.values.energia_injetada : null,
        energia_registrada: formik.values.energia_registrada ? formik.values.energia_registrada : null,
        energia_compensada: formik.values.energia_compensada ? formik.values.energia_compensada : null,
        leitura_atual: formik.values.leitura_atual ? formik.values.leitura_atual : null,
        leitura_anterior: formik.values.leitura_anterior ? formik.values.leitura_anterior : null,
        proxima_leitura: formik.values.leitura_proxima ? formik.values.leitura_proxima : null,
        tarifa: formik.values.tarifa ? formik.values.tarifa : null,
        tipo_fornecimento: formik.values.tipo_fornecimento ? formik.values.tipo_fornecimento : null,
        valor_faturado: formik.values.valor_faturado ? formik.values.valor_faturado : null,
        valor_economizado: formik.values.valor_economizado ? formik.values.valor_economizado : null,
        link_file: formik.values.link_file !== undefined ? formik.values.link_file : null,
        creditos: formik.values.creditos ? formik.values.creditos : null,
        base64: formik.values.base64 ? formik.values.base64 : null,
        confirm_payment: formik.values.confirm_payment ? formik.values.confirm_payment : false,
        idUnitConsumer: formik.values.idUnitConsumer ? formik.values.idUnitConsumer : null,
        
        taxa_iluminacao: formik.values.taxa_iluminacao ? formik.values.taxa_iluminacao : null,
        icms: formik.values.icms ? formik.values.icms : null,
        pis: formik.values.pis ? formik.values.pis : null,
        cofins: formik.values.cofins ? formik.values.cofins : null,

        valor_consumido: formik.values.valor_consumido ? formik.values.valor_consumido : null,
        codigo_instalacao: formik.values.codigo_instalacao != null && formik.values.codigo_instalacao !== ''
          ? formik.values.codigo_instalacao
          : null,
        grupo_tarifario: formik.values.tipo_fatura_ab != null
          ? formik.values.tipo_fatura_ab
          : null,
        modalidade_tarifaria: formik.values.modalidade_tarifaria != null && formik.values.modalidade_tarifaria !== ''
          ? formik.values.modalidade_tarifaria
          : null,
        concessionaria: formik.values.concessionaria != null && formik.values.concessionaria !== ''
          ? formik.values.concessionaria
          : null,
        regulamentacao_aneel: !!formik.values.regulamentacao_aneel,
        demanda_contratada_kw: formik.values.demanda_contratada_kw != null && formik.values.demanda_contratada_kw !== ''
          ? formik.values.demanda_contratada_kw
          : null,
        demanda_medida_kw: formik.values.demanda_medida_kw != null && formik.values.demanda_medida_kw !== ''
          ? formik.values.demanda_medida_kw
          : null,
        demanda_faturada_kw: formik.values.demanda_faturada_kw != null && formik.values.demanda_faturada_kw !== ''
          ? formik.values.demanda_faturada_kw
          : null,
        ultrapassagem_kw: formik.values.ultrapassagem_kw != null && formik.values.ultrapassagem_kw !== ''
          ? formik.values.ultrapassagem_kw
          : null,
        fator_potencia: formik.values.fator_potencia != null && formik.values.fator_potencia !== ''
          ? formik.values.fator_potencia
          : null,
        consumo_ponta_kwh: formik.values.consumo_ponta_kwh != null && formik.values.consumo_ponta_kwh !== ''
          ? formik.values.consumo_ponta_kwh
          : null,
        consumo_fora_ponta_kwh:
          formik.values.consumo_fora_ponta_kwh != null && formik.values.consumo_fora_ponta_kwh !== ''
            ? formik.values.consumo_fora_ponta_kwh
            : null,
        bandeira_tarifaria_vigente:
          formik.values.bandeira_tarifaria_vigente != null && formik.values.bandeira_tarifaria_vigente !== ''
            ? formik.values.bandeira_tarifaria_vigente
            : null,
        tarifa_tusd: formik.values.tarifa_tusd != null && formik.values.tarifa_tusd !== '' ? formik.values.tarifa_tusd : null,
        tarifa_te: formik.values.tarifa_te != null && formik.values.tarifa_te !== '' ? formik.values.tarifa_te : null,
        tarifa_media: formik.values.tarifa_media != null && formik.values.tarifa_media !== '' ? formik.values.tarifa_media : null,
        tarifa_tusd_ponta:
          formik.values.tarifa_tusd_ponta != null && formik.values.tarifa_tusd_ponta !== ''
            ? formik.values.tarifa_tusd_ponta
            : null,
        tarifa_tusd_fora_ponta:
          formik.values.tarifa_tusd_fora_ponta != null && formik.values.tarifa_tusd_fora_ponta !== ''
            ? formik.values.tarifa_tusd_fora_ponta
            : null,
        tarifa_te_ponta:
          formik.values.tarifa_te_ponta != null && formik.values.tarifa_te_ponta !== ''
            ? formik.values.tarifa_te_ponta
            : null,
        tarifa_te_fora_ponta:
          formik.values.tarifa_te_fora_ponta != null && formik.values.tarifa_te_fora_ponta !== ''
            ? formik.values.tarifa_te_fora_ponta
            : null,
        tarifa_demanda_contratada:
          formik.values.tarifa_demanda_contratada != null && formik.values.tarifa_demanda_contratada !== ''
            ? formik.values.tarifa_demanda_contratada
            : null,
        preco_unitario_ponta:
          formik.values.preco_unitario_ponta != null && formik.values.preco_unitario_ponta !== ''
            ? formik.values.preco_unitario_ponta
            : null,
        preco_unitario_fora_ponta:
          formik.values.preco_unitario_fora_ponta != null && formik.values.preco_unitario_fora_ponta !== ''
            ? formik.values.preco_unitario_fora_ponta
            : null,
        contrib_ilum_publica:
          formik.values.contrib_ilum_publica != null && formik.values.contrib_ilum_publica !== ''
            ? formik.values.contrib_ilum_publica
            : null,
        itens_faturamento_json:
          formik.values.itens_faturamento_json != null && formik.values.itens_faturamento_json !== ''
            ? formik.values.itens_faturamento_json
            : null,
        medicao_json:
          formik.values.medicao_json != null && formik.values.medicao_json !== '' ? formik.values.medicao_json : null,
        historico_consumo_json:
          formik.values.historico_consumo_json != null && formik.values.historico_consumo_json !== ''
            ? formik.values.historico_consumo_json
            : null,
        tarifas_json:
          formik.values.tarifas_json != null && formik.values.tarifas_json !== '' ? formik.values.tarifas_json : null,
        demandas_grupo_a_json:
          formik.values.demandas_grupo_a_json != null && formik.values.demandas_grupo_a_json !== ''
            ? formik.values.demandas_grupo_a_json
            : null,
        impostos_json:
          formik.values.impostos_json != null && formik.values.impostos_json !== '' ? formik.values.impostos_json : null,

        status: 
          formik.values.energia_faturada && 
          formik.values.energia_registrada && 
          formik.values.leitura_atual &&
          formik.values.leitura_anterior &&
          formik.values.tarifa &&
          formik.values.valor_faturado
          ? "INFORMADO" : formik.values.status,
      }
      Object.keys(myData).forEach((prop) => {
        if (myData[prop] === null) {
          delete myData[prop];
        }
      });
      await updateInvoice(id, myData)
      toggleToast("Sucesso ao atualizar a fatura. ", "success")

    } catch (error) {
      console.log(error)
      toggleToast("Erro ao atualizar a fatura. ", "error")
    }finally{
      setLoading(false)
      closed()
      // handleClose()
      // setTimeout(()=>{
      //   window.location.reload()
      // }, 3000);
    }
  }

  const submit = () => {
    if(id){
      updateUnitConsumerSubmit(id)
    }else{
      //postUnitConsumerSubmit()
    }
  }

  const nextStep = () => {
    setHasError(false)
    if (!checkInputs()) {
    setHasError(true)
    return
    }
    submit()
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    validateOnChange: false,
    onSubmit: nextStep,
  });


  useEffect(() => {
    if(data){
      const myObject = {
        mes: data.mes ? data.mes :  new Date(),
        data_vencimento: data.data_vencimento ? data.data_vencimento : null,
        energia_faturada: data.energia_faturada ? data.energia_faturada : null,
        energia_injetada: data.energia_injetada ? data.energia_injetada : null,
        energia_registrada: data.energia_registrada ? data.energia_registrada : null,
        energia_compensada: data.energia_compensada ? data.energia_compensada : null,
        leitura_atual: data.leitura_atual ? data.leitura_atual : new Date().toString(),
        leitura_anterior: data.leitura_anterior ? data.leitura_anterior : new Date().toString(),
        leitura_proxima: data.leitura_proxima ? data.leitura_proxima : null,
        tarifa: data.tarifa ? data.tarifa : null,
        tipo_fornecimento: data.tipo_fornecimento ? data.tipo_fornecimento : null,
        valor_faturado: data.valor_faturado ? data.valor_faturado : null,
        valor_economizado: data.valor_economizado ? data.valor_economizado : null,
        link_file: data.link_file ? data.link_file : null,
        base64: data.base64 ? data.link_file : null,
        status: data.status ? data.status : null,
        creditos: data.creditos ? data.creditos : null,
        idConcessionarie: data.idConcessionarie ? data.idConcessionarie : null,
        idUnitConsumer: data.idUnitConsumer ? data.idUnitConsumer : null,
        confirm_payment: data.confirm_payment ? data.confirm_payment : false,

        taxa_iluminacao: data.taxa_iluminacao ? data.taxa_iluminacao : null,
        icms: data.icms ? data.icms : null,
        pis: data.pis ? data.pis : null,
        cofins: data.cofins ? data.cofins : null,

        valor_consumido: data.valor_consumido != null ? String(data.valor_consumido) : null,
        codigo_instalacao: data.codigo_instalacao != null ? String(data.codigo_instalacao) : null,
        grupo_tarifario: data.grupo_tarifario != null ? String(data.grupo_tarifario) : null,
        tipo_fatura_ab: tipoFaturaAbFromGrupo(data.grupo_tarifario != null ? String(data.grupo_tarifario) : null),
        modalidade_tarifaria: data.modalidade_tarifaria != null ? String(data.modalidade_tarifaria) : null,
        concessionaria: data.concessionaria != null ? String(data.concessionaria) : null,
        regulamentacao_aneel:
          typeof data.regulamentacao_aneel === 'boolean' ? data.regulamentacao_aneel : false,
        demanda_contratada_kw: data.demanda_contratada_kw != null ? String(data.demanda_contratada_kw) : null,
        demanda_medida_kw: data.demanda_medida_kw != null ? String(data.demanda_medida_kw) : null,
        demanda_faturada_kw: data.demanda_faturada_kw != null ? String(data.demanda_faturada_kw) : null,
        ultrapassagem_kw: data.ultrapassagem_kw != null ? String(data.ultrapassagem_kw) : null,
        fator_potencia: data.fator_potencia != null ? String(data.fator_potencia) : null,
        consumo_ponta_kwh: data.consumo_ponta_kwh != null ? String(data.consumo_ponta_kwh) : null,
        consumo_fora_ponta_kwh: data.consumo_fora_ponta_kwh != null ? String(data.consumo_fora_ponta_kwh) : null,
        bandeira_tarifaria_vigente:
          data.bandeira_tarifaria_vigente != null ? String(data.bandeira_tarifaria_vigente) : null,
        tarifa_tusd: data.tarifa_tusd != null ? String(data.tarifa_tusd) : null,
        tarifa_te: data.tarifa_te != null ? String(data.tarifa_te) : null,
        tarifa_media: data.tarifa_media != null ? String(data.tarifa_media) : null,
        tarifa_tusd_ponta: data.tarifa_tusd_ponta != null ? String(data.tarifa_tusd_ponta) : null,
        tarifa_tusd_fora_ponta: data.tarifa_tusd_fora_ponta != null ? String(data.tarifa_tusd_fora_ponta) : null,
        tarifa_te_ponta: data.tarifa_te_ponta != null ? String(data.tarifa_te_ponta) : null,
        tarifa_te_fora_ponta: data.tarifa_te_fora_ponta != null ? String(data.tarifa_te_fora_ponta) : null,
        tarifa_demanda_contratada:
          data.tarifa_demanda_contratada != null ? String(data.tarifa_demanda_contratada) : null,
        preco_unitario_ponta: data.preco_unitario_ponta != null ? String(data.preco_unitario_ponta) : null,
        preco_unitario_fora_ponta:
          data.preco_unitario_fora_ponta != null ? String(data.preco_unitario_fora_ponta) : null,
        contrib_ilum_publica: data.contrib_ilum_publica != null ? String(data.contrib_ilum_publica) : null,
        itens_faturamento_json:
          typeof data.itens_faturamento_json === 'string'
            ? data.itens_faturamento_json
            : data.itens_faturamento_json != null
              ? JSON.stringify(data.itens_faturamento_json)
              : null,
        medicao_json:
          typeof data.medicao_json === 'string'
            ? data.medicao_json
            : data.medicao_json != null
              ? JSON.stringify(data.medicao_json)
              : null,
        historico_consumo_json:
          typeof data.historico_consumo_json === 'string'
            ? data.historico_consumo_json
            : data.historico_consumo_json != null
              ? JSON.stringify(data.historico_consumo_json)
              : null,
        tarifas_json:
          typeof data.tarifas_json === 'string'
            ? data.tarifas_json
            : data.tarifas_json != null
              ? JSON.stringify(data.tarifas_json)
              : null,
        demandas_grupo_a_json:
          typeof data.demandas_grupo_a_json === 'string'
            ? data.demandas_grupo_a_json
            : data.demandas_grupo_a_json != null
              ? JSON.stringify(data.demandas_grupo_a_json)
              : null,
        impostos_json:
          typeof data.impostos_json === 'string'
            ? data.impostos_json
            : data.impostos_json != null
              ? JSON.stringify(data.impostos_json)
              : null,
      }
      formik.setValues(myObject)
    }else{
      formik.setValues(initialValues)
    }
  }, [show])


  const missingFields = [
    !formik.values.idUnitConsumer && 'unidade consumidora',
    !formik.values.leitura_anterior && 'leitura anterior',
    !formik.values.energia_registrada && 'energia registrada',
    !formik.values.energia_faturada && 'energia faturada',
    !formik.values.valor_faturado && 'valor faturado',
    !formik.values.tarifa && 'tarifa',
  ].filter(Boolean)

  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog modal-dialog-centered modal-xl'
      fullscreen='xl-down'
      show={show}
      onHide={closed}
      backdrop={true}
    >
      <div className='modal-header py-5'>
        <div className={styles.header}>
          <span className={styles.headerIcon}>
            <KTSVG
              path='/media/icons/duotune/files/fil003.svg'
              className='svg-icon-1 svg-icon-primary'
            />
          </span>
          <div>
            <h3 className={styles.headerTitle}>{id ? 'Editar fatura' : 'Nova fatura'}</h3>
            <span className={styles.headerSubtitle}>
              Revise os dados extraídos ou envie o PDF para preencher automaticamente
            </span>
          </div>
        </div>

        <button
          type='button'
          className='btn btn-sm btn-icon btn-active-color-primary'
          onClick={closed}
          aria-label='Fechar'
        >
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </button>
      </div>

      <div className={`modal-body ${styles.body}`}>
        <form noValidate id='kt_modal_create_app_form'>
          <StepModal
            data={initialValues}
            updateData={updateData}
            hasError={hasError}
            formik={formik}
            id={id}
          />
        </form>
      </div>

      <div className={`modal-footer ${styles.footer}`}>
        {hasError && missingFields.length > 0 ? (
          <span className={styles.footerError}>
            <KTSVG
              path='/media/icons/duotune/general/gen044.svg'
              className='svg-icon-3 svg-icon-danger'
            />
            Preencha os campos obrigatórios: {missingFields.join(', ')}
          </span>
        ) : (
          <span className={styles.footerHint}>
            Campos com <span className='text-danger'>*</span> são obrigatórios
          </span>
        )}

        <div className={styles.footerActions}>
          <button type='button' className='btn btn-light' onClick={closed} disabled={loading}>
            Cancelar
          </button>
          <button type='button' className='btn btn-primary' disabled={loading} onClick={nextStep}>
            {loading ? (
              <>
                Salvando <LoadingSpan style={{marginLeft: '0.5rem'}} />
              </>
            ) : (
              <>
                <KTSVG path='/media/icons/duotune/arrows/arr085.svg' className='svg-icon-3 me-1' />
                {id ? 'Salvar alterações' : 'Cadastrar fatura'}
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>,
    modalsRoot
  )
}

export {ModalAddUpdateInvoice}
